import type { AuthPhase } from '@/types/profileTypes';

export interface IdentityLinkRoutingInput {
  /** true once the "Who are you?" (generalProfile) step has been shown */
  encounteredGeneralProfile: boolean;
  /** set when the alternate contact matched an existing account */
  discoveredAccountId: string | null;
  /** selected roles with the 'None' sentinel already removed */
  realRoles: string[];
}

export type IdentityLinkRoute = { phase: AuthPhase } | { complete: true };

/**
 * Where the flow goes after the identity-linking OTP (verified OR skipped).
 *
 * The OTP step is reached from two places. After the profile step it always was, and
 * the flow continues to the role profiles or completes. Since the phone typed at
 * "Add Mobile Phone" is actually linked (fix/signup-phone-single-ask), it is also
 * reached BEFORE the profile step; continuing to "complete" from there finished the
 * account with no name and no role and bounced the participant back to
 * "Add Mobile Phone" (local pass, 2026-09-13). In that case the profile step is next.
 */
export function phaseAfterIdentityLink(input: IdentityLinkRoutingInput): IdentityLinkRoute {
  if (!input.encounteredGeneralProfile) {
    return { phase: input.discoveredAccountId ? 'accountDiscovery' : 'generalProfile' };
  }
  if (input.realRoles.length > 0) {
    return { phase: `${input.realRoles[0].toLowerCase()}Profile` as AuthPhase };
  }
  return { complete: true };
}
